interface FieldTypeMap {
    [key: string]: string;
}

export const fieldTypes: FieldTypeMap = {
    text: "Text",
    textarea: "Text Area",
    number: "Number",
    dollar: "Currency",
    percentage: "Percentage",
    location: "Location",
    email: "Email",
    phone: "Phone",
    date: "Date",
    encrypted: "Encrypted",
    //mask: "Mask", TODO: customize this field type
    dropdown: "Custom Dropdown",
    radio: "Custom Radios",
    radioFloatingRate: "Radio Floating Rate",
    borrowercontact: "Borrower Contact Dropdown",
    loancontact: "Loan Contact Dropdown",
    property: "Property Dropdown",
};
